import { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import {
    Form,
    InputGroup,
    Button,
    Spinner,
    Modal,
    Alert,
    Row, Col,
    Tab,
    Nav,
} from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { StoreProptypes } from "../../PropTypes/StoreProptypes";
import EditCompanyInformation from "./CompanyInformation";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import { LOADING, SET_CURRENT_WEBSITE, SET_MESSAGE } from "../../Actions/Types";
import { updateUserService } from "../../Services/UserAction/UpdateUserDetails";
import { deleteAccountDetails } from "../../Services/UserAction/DeleteAccountService";
import { useAuth0 } from "@auth0/auth0-react";
import { useNavigate } from "react-router-dom";
import getBaseURL from "../../Helpers/getBaseURL";
import { verifyLoginCode } from "../../Api/TwoFactorAuthAPI";
import { getUserDetailsApi } from "../../Api/UserAction/LoginActionApi";
import { useTheme } from "../../Context/ThemeContext";
import select2LangPropTypes from "../../PropTypes/select2LangPropTypes";
import Select from "react-select";
import { getCountryListService } from "../../Services/BillingAddressService";
import getEUCountryListwithID from "../../Helpers/EUCountryListWithId";
import EUServerMigrationPopup from "../EUServerMigrationPopup";
import { postUserActivityListService } from "../../Services/UserActivityService";
import { UpdateEUFlagDomainService } from "../../Services/DomainService/UpdateEUFlagDomain";
import compareDates from "../../Helpers/DateCompare";
import isGreater from "../../Helpers/DateCompare";
import BillingAddressManager from "../../Pages/UserModule/BillingAddressManager";

const darkThemeStyles = {
    container: {
        backgroundColor: '#0F0F1A',
    },
    input: {
        backgroundColor: 'black',
        borderColor: '#555',
        color: '#fff',
    },
    button: {
        backgroundColor: '#333',
        borderColor: '#555',
        ':hover': {
            backgroundColor: '#444',
        },
    },
    dropdown: {
        backgroundColor: '#0F0F1A',
        color: '#fff',
        ':hover': {
            backgroundColor: 'black',
        },
    },
    search: {
        backgroundColor: 'black',
        color: 'black',
        ':hover': {
            backgroundColor: 'black',
        },
    },
};

const euServerStartDate = `${process.env.REACT_APP_EU_START_DATE}`;

// component to display edit personal information form
const EditPersonalInformation = () => {
    const { t } = useTranslation();

    const theme = useTheme()

    const dispatch = useDispatch();
    const navigate = useNavigate();

    const {
        user,
        accessToken,
        activeLanguage,
        languageList,
        activeEditLanguage,
        isUserDeleted,
        currentWebsite,
    } = useSelector((store: StoreProptypes) => store);
    console.log("user: ", user?.is_eu_script_show);

    const [activeTab, setActiveTab] = useState<string>("personal");
    const [fullName, setFullName] = useState("");
    const [userEmail, setUserEmail] = useState("");
    const [phone, setPhone] = useState("");
    const [language, setLanguage] = useState("");

    const [companyWebsiteURL, setCompanyWebsiteURL] = useState("");
    const [companyName, setCompanyName] = useState("");
    const { logout, isAuthenticated } = useAuth0();
    const [isDeleteAccountConfirmed, setIsDeleteAccountConfirmed] =
        useState<boolean>(false);
    const [isAccountDeleted, setIsAccountDeleteted] = useState<boolean>(false);
    const [isGoogle2FAEnabled, setIsGoogle2FAEnabled] = useState<Boolean>(false);
    const [isShowGoogle2FAEnabledScreen, setIsShowGoogle2FAEnabledScreen] =
        useState<Boolean>(false);
    const [otp, setOtp] = useState("");
    const [error, setError] = useState("");
    const [showEmailChangeConfirm, setShowEmailChangeConfirm] = useState(false);
    const [newEmailTemp, setNewEmailTemp] = useState("");
    const [showEmailOTPModal, setShowEmailOTPModal] = useState(false);
    const [emailOtp, setEmailOtp] = useState("");
    const [emailOtpError, setEmailOtpError] = useState("");
    const [country, setCountry] = useState<select2LangPropTypes>();
    const [countryList, setCountryList] = useState<select2LangPropTypes[]>([]);
    const [isCountryChanged, setIsCountryChanged] = useState<boolean>(false);
    const [isMigratedFromNonEU, setIsMigratedFromNonEU] =
        useState<boolean>(false);
    const getEUCoutryListsId = getEUCountryListwithID();

    useEffect(() => {
        if (accessToken) {
            // service to get card list
            getCountryListService(accessToken, setCountryList);
        }
    }, [accessToken]);
  const [disabledButton, setDisabledButton] = useState<boolean>(false);
        // Disabled Button Functions complete dependency
    useEffect(() => {
        if (user?.department === 1 || (user?.parent_id !== 0 &&  user?.parent_id !== 1)) {
            setDisabledButton(true);
        } else {
            setDisabledButton(false);
        }
    }, [user]);

    useEffect(() => {
        if (activeEditLanguage) {
            setLanguage(activeEditLanguage.code);
        } else {
            setLanguage("en");
        }
    }, [activeEditLanguage]);

    const getUser = (): void => {
        if (accessToken) {
            getUserDetailsApi(accessToken)
                .then((res) => {
                    if (res?.Data) {
                        setIsGoogle2FAEnabled(res?.Data?.is_google2fa_enabled === 1);
                    }
                })
                .catch((err) => {
                    dispatch({
                        type: SET_MESSAGE,
                        payload: {
                            toast_message: `${err}`,
                            toast_type: "danger",
                        },
                    });
                });
        }
    };

    useEffect(() => {
        getUser();
        if (!isAccountDeleted && isUserDeleted) {
            navigate("/front/login?logout");
        }
    }, [user, navigate]);

    useEffect(() => {
        // check if user data is available
        if (user) {
            user.name && setFullName(user.name);
            user.email && setUserEmail(user.email);
            user.email && setNewEmailTemp(user.email);
            user.company_name && setCompanyName(user.company_name);
            user.phone && setPhone(user.phone);
            user.website && setCompanyWebsiteURL(user.website);
        }
    }, [user]);

    // apply temp email (if changed)
    const proceedUpdate = (finalEmail: string) => {
        // Validation (same as your existing validation)
        if (finalEmail === "") {
            dispatch({
                type: SET_MESSAGE,
                payload: {
                    toast_message: t("Please enter your email address"),
                    toast_type: "danger",
                },
            });
            return;
        }

        if (!/[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,15}/g.test(finalEmail)) {
            dispatch({
                type: SET_MESSAGE,
                payload: {
                    toast_message: t("Please enter valid email address."),
                    toast_type: "danger",
                },
            });
            return;
        }

        if (phone === "") {
            dispatch({
                type: SET_MESSAGE,
                payload: {
                    toast_message: t("Please enter your phone number."),
                    toast_type: "danger",
                },
            });
            return;
        }

        if (fullName === "") {
            dispatch({
                type: SET_MESSAGE,
                payload: {
                    toast_message: t("Please enter your full name."),
                    toast_type: "danger",
                },
            });
            return;
        }

        // check if user and access token is available, then call update user service
        var findCountry = [];
        if (country) {
            findCountry = getEUCoutryListsId.filter(
                (d) => d.id.toString() == country.value
            );
        }

        user &&
        accessToken &&
        updateUserService(
            {
                ...user,
                name: fullName,
                phone: phone,
                email: finalEmail,
                company_name: companyName,
                default_lang_code: language,
                website: companyWebsiteURL,
                country: country ? Number(country.value) : 0,
            },
            accessToken,
            dispatch,
            t,
            undefined,
            undefined,
            languageList || []
        );

        let is_eu_script_show = 1;
        let no_required_eu = 1;

        if (isCountryChanged) {
            is_eu_script_show = 0; // when country changed, we reset script show

            if (findCountry.length > 0) {
                no_required_eu = 0; // if country list found
            } else {
                no_required_eu = 1; // fallback
            }

            accessToken &&
            currentWebsite &&
            UpdateEUFlagDomainService(
                accessToken,
                dispatch,
                currentWebsite.id,
                is_eu_script_show,
                currentWebsite.is_eu_script_show_first,
                no_required_eu
            ).then((d) => {
                if (d.status === 200) {
                    if (isCountryChanged && findCountry.length > 0 && accessToken) {
                        postUserActivityListService(
                            accessToken,
                            "Migrate to EU",
                            "User requested to migrate EU"
                        );
                    }
                    dispatch({
                        type: SET_CURRENT_WEBSITE,
                        payload: {
                            ...currentWebsite,
                            ...(isCountryChanged ? { is_eu_script_show: 0 } : {}),
                            ...(isCountryChanged && findCountry.length > 0
                                ? { no_required_eu: 0 }
                                : {}),
                        },
                    });
                }
            });
        }

        setIsCountryChanged(false);
    };

    useEffect(() => {
        // check if user data is available
        if (user) {
            user.country &&
            setCountry(countryList.find((d) => d.value == user.country.toString()));
            console.log("countryList: ", countryList);
        }
    }, [user, countryList]);

    // function to handle form submit
    const HandleSubmit = (e: React.MouseEvent<HTMLButtonElement>) => {
        e.preventDefault();

        if (newEmailTemp && newEmailTemp !== userEmail) {
            // email changed → show confirmation modal
            setShowEmailChangeConfirm(true);
            return;
        }

        proceedUpdate(userEmail);
    };

    // function to hide widget script modal
    const handleDeleteAccountModel = () => {
        setIsShowGoogle2FAEnabledScreen(false);
        setIsDeleteAccountConfirmed(false);
        setOtp("");
        setError("");
    };

    // function to handle email change confirmation
    const handleEmailChangeConfirm = () => {
        if (isGoogle2FAEnabled) {
            setShowEmailChangeConfirm(false);
            setShowEmailOTPModal(true);
        } else {
            setUserEmail(newEmailTemp);
            setShowEmailChangeConfirm(false);
            proceedUpdate(newEmailTemp);
        }
    };

    // function to confirm email change with OTP
    const confirmEmailChangeWithOTP = async () => {
        const trimmedCode = emailOtp.trim();
        const isValidOTP = /^\d{6}$/.test(trimmedCode);
        const isValidRecovery = /^[a-zA-Z0-9]{8,24}$/.test(trimmedCode);

        if (!isValidOTP && !isValidRecovery) {
            setEmailOtpError(t("Please enter a valid 6-digit code or recovery code."));
            return;
        }

        setEmailOtpError("");

        try {
            const response = await verifyLoginCode({
                token: accessToken,
                code: trimmedCode,
            });

            if (!response?.status) {
                setEmailOtpError(t("Verification failed. Please try again."));
            } else {
                setUserEmail(newEmailTemp);
                setShowEmailOTPModal(false);
                setEmailOtp("");
                proceedUpdate(newEmailTemp);
            }
        } catch {
            setEmailOtpError(t("Error verifying 2FA. Please try again."));
        }
    };

    // function to close email OTP modal
    const handleEmailOTPModalClose = () => {
        setShowEmailOTPModal(false);
        setEmailOtp("");
        setEmailOtpError("");
        setNewEmailTemp(userEmail);
    };

    // function to hide widget script modal
    const handleAccountDeletedModelModel = () => {
        setIsShowGoogle2FAEnabledScreen(false);
        setIsDeleteAccountConfirmed(false);
    };

    const deleteAccount = (e: React.MouseEvent<HTMLButtonElement>) => {
        e.preventDefault();
        setIsDeleteAccountConfirmed(true);
    };

    const confirmDeleteAccount = async () => {
        if (isGoogle2FAEnabled && !isShowGoogle2FAEnabledScreen) {
            setIsShowGoogle2FAEnabledScreen(true);
        } else if (isShowGoogle2FAEnabledScreen && accessToken) {
            const trimmedCode = otp.trim();

            const isValidOTP = /^\d{6}$/.test(trimmedCode);
            const isValidRecovery = /^[a-zA-Z0-9]{8,24}$/.test(trimmedCode);

            if (!isValidOTP && !isValidRecovery) {
                setError(t("Please enter a valid 6-digit code or recovery code."));
                return;
            }

            dispatch({
                type: LOADING,
                payload: false,
            });
            setError("");

            try {
                const response = await verifyLoginCode({
                    token: accessToken,
                    code: trimmedCode,
                });

                if (!response?.status) {
                    setError(t("Verification failed. Please try again."));
                } else {
                    deleteAccountDetails(accessToken, dispatch, navigate, t);
                    setIsDeleteAccountConfirmed(false);
                    setIsAccountDeleteted(true);
                }
            } catch {
                setError(t("Error verifying 2FA. Please try again."));
            }
        } else {
            if (accessToken) {
                deleteAccountDetails(accessToken, dispatch, navigate, t);
                setIsDeleteAccountConfirmed(false);
                setIsAccountDeleteted(true);
            }
        }
    };

    const navigateDeletedAccount = () => {
        if (isAuthenticated) {
            dispatch({
                type: LOADING,
                payload: false,
            });
            const baseURL = getBaseURL();
            setTimeout(() => {
                logout({ logoutParams: { returnTo: `${baseURL}/front/login?logout` } });
            }, 300);
        } else {
            navigate("/front/login?logout");
            dispatch({
                type: LOADING,
                payload: false,
            });
        }
    };

    const revertBackToOriginalLanguage = () => {
        if (user) {
            user.country &&
            setCountry(countryList.find((d) => d.value == user.country.toString()));
        }
        setIsCountryChanged(false);
        setIsMigratedFromNonEU(false);
    };

    return (
        <>
            <Form>
                <div className="card">
                    {/* <div className="card-header">
                        <h2 className="mb-0 h6">{t("Profile Settings")}</h2>
                    </div> */}
                    
                    {/* Tabs Navigation */}
                    <Tab.Container activeKey={activeTab} onSelect={(k) => setActiveTab(k || "personal")}>
                        <div className=" p-0 border-bottom">
                            <Nav variant="tabs" className="px-3 pt-2">
                                <Nav.Item>
                                    <Nav.Link eventKey="personal">
                                        {t("Personal Information")}
                                    </Nav.Link>
                                </Nav.Item>
                                <Nav.Item>
                                    <Nav.Link eventKey="company">
                                        {t("Company Information")}
                                    </Nav.Link>
                                </Nav.Item>
                                 <Nav.Item>
                                    <Nav.Link eventKey="Address">
                                        {t("Address Information")}
                                    </Nav.Link>
                                </Nav.Item>
                            </Nav>
                        </div>
                        
                        <Tab.Content>
                            {/* Personal Information Tab */}
                            <Tab.Pane eventKey="personal" className="p-3">
                                <Row>
                                    {/* Full Name */}
                                    <Col md={6}>
                                        <Form.Label htmlFor="fullName">
                                            {t("Full Name")} <span className="text-danger">*</span>
                                        </Form.Label>
                                        <InputGroup className="mb-3 input-group-outline">
                                            <Form.Control
                                                id="fullName"
                                                type="text"
                                                value={fullName}
                                                size="lg"
                                                onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                                                    setFullName(e.target.value)
                                                }
                                                required
                                            />
                                        </InputGroup>
                                    </Col>

                                    {/* Email */}
                                    <Col md={6}>
                                        <Form.Label htmlFor="email">
                                            {t("E-Mail")} <span className="text-danger">*</span>
                                        </Form.Label>
                                        <InputGroup className="mb-3 input-group-outline">
                                            <Form.Control
                                                id="email"
                                                type="email"
                                                value={newEmailTemp}
                                                size="lg"
                                                onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                                                    setNewEmailTemp(e.target.value)
                                                }
                                                required
                                            />
                                        </InputGroup>
                                    </Col>

                                    {/* Language */}
                                    <Col md={6}>
                                        <Form.Label htmlFor="language">{t("Language")}</Form.Label>
                                        <InputGroup className="mb-3 input-group-outline">
                                            <Form.Select
                                                value={language}
                                                onChange={(e) => setLanguage(e.currentTarget.value)}
                                            >
                                                {languageList?.map((item) => (
                                                    <option key={item.code} value={item.code}>
                                                        {t(item.original_name)}
                                                    </option>
                                                ))}
                                            </Form.Select>
                                        </InputGroup>
                                    </Col>

                                    {/* Phone */}
                                    <Col md={6}>
                                        <Form.Label htmlFor="phone">
                                            {t("Phone")} <span className="text-danger">*</span>
                                        </Form.Label>
                                        <InputGroup
                                            className={`mb-3 input-group-outline phone-number ${
                                                theme.theme === "dark" ? "darkmode" : ""
                                            }`}
                                        >
                                            <PhoneInput
                                                country={"us"}
                                                value={phone}
                                                onChange={(phone) => setPhone(phone)}
                                                inputProps={{ id: "phone", required: "required" }}
                                                containerStyle={theme.theme === "dark" ? darkThemeStyles.container : {}}
                                                inputStyle={theme.theme === "dark" ? darkThemeStyles.input : {}}
                                                buttonStyle={theme.theme === "dark" ? darkThemeStyles.button : {}}
                                                dropdownStyle={theme.theme === "dark" ? darkThemeStyles.dropdown : {}}
                                                searchStyle={theme.theme === "dark" ? darkThemeStyles.search : {}}
                                            />
                                        </InputGroup>
                                    </Col>
                                </Row>
                                 <div className="card-body border-top">
                                     <div className="profile-action-wrapper d-flex gap-2 mt-2">
                                        <Button
                                            type="submit"
                                            variant="primary"
                                            onClick={(e) => HandleSubmit(e)}
                                            // size="lg"
                                        >
                                            {t("Update Profile")}
                                        </Button>

                                        <Button
                                            type="button"
                                            variant="danger"
                                            onClick={(e) => deleteAccount(e)}
                                            // size="lg"
                                        >
                                            {t("delete account")}
                                        </Button>
                                        </div>
                                    </div>
                                </Tab.Pane>
                            
                            {/* Company Information Tab */}
                            <Tab.Pane eventKey="company" className="p-3">
                                <EditCompanyInformation
                                    companyWebsiteURL={companyWebsiteURL}
                                    setCompanyWebsiteURL={setCompanyWebsiteURL}
                                    companyName={companyName}
                                    setCompanyName={setCompanyName}
                                />
                                 <div className="card-body border-top">
                                    <div className="profile-action-wrapper d-flex gap-2 mt-2">
                                        <Button
                                            type="submit"
                                            variant="primary"
                                            onClick={(e) => HandleSubmit(e)}
                                            // size="lg"
                                        >
                                            {t("Update Profile")}
                                        </Button>

                                        <Button
                                            type="button"
                                            variant="danger"
                                            onClick={(e) => deleteAccount(e)}
                                            // size="lg"
                                        >
                                            {t("delete account")}
                                        </Button>
                                    </div>
                                  </div>
                            </Tab.Pane>

                             {/* Address Information Tab */}
                            <Tab.Pane eventKey="Address" className="p-3">
                               <BillingAddressManager disabledButton={disabledButton} />
                            </Tab.Pane>
                        </Tab.Content>
                    </Tab.Container>
                    
                    {/* Buttons - placed outside tabs to be consistent across both tabs */}
                   
                </div>
            </Form>

            {/* All modals remain the same */}
            {/* Confirm Popup for Delete Account Website */}
            <Modal
                show={isDeleteAccountConfirmed}
                onHide={() => handleDeleteAccountModel()}
                size="lg"
                backdrop="static"
                centered
            >
                <Modal.Header closeButton>
                    <Modal.Title>{t("delete account")}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {!isShowGoogle2FAEnabledScreen ? (
                        <div className="mb-3">
                            <div className="mb-3">
                                {t(
                                    "This action is permanent. Your account and all related data will be deleted within 48 hours, and you will no longer be able to access them."
                                )}
                            </div>
                            <b>{t("are you sure you want to delete your account?")}</b>
                        </div>
                    ) : (
                        <>
                            <Form.Label htmlFor="otp">
                                {t("authentication code or recovery code")}{" "}
                                <span className="text-danger">*</span>
                            </Form.Label>
                            <InputGroup className="mb-3">
                                <Form.Control
                                    type="text"
                                    aria-label="OTP"
                                    placeholder={t("enter 6-digit OTP or recovery code")}
                                    onChange={(e) => setOtp(e.target.value)}
                                    value={otp}
                                    maxLength={24}
                                    size="lg"
                                />
                            </InputGroup>
                            {error && (
                                <Alert variant="danger" className="mt-3">
                                    {error}
                                </Alert>
                            )}
                        </>
                    )}
                </Modal.Body>
                <Modal.Footer>
                    <Button
                        variant="danger"
                        size="lg"
                        onClick={() => confirmDeleteAccount()}
                    >
                        {t("confirm")}
                    </Button>
                    <Button
                        variant="primary"
                        size="lg"
                        onClick={() => handleDeleteAccountModel()}
                    >
                        {t("Cancel")}
                    </Button>
                </Modal.Footer>
            </Modal>

            {/* Delete information popup */}
            <Modal
                show={isAccountDeleted}
                onHide={() => navigateDeletedAccount()}
                size="lg"
                fullscreen="lg-down"
                backdrop="static"
                centered
            >
                <Modal.Header>
                    <Modal.Title>{t("Account Deleted")}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {t(
                        "Your account deletion request has been submitted successfully. You will no longer be able to access your account and all your data will be permanently removed from our system within 48 hours. If you have any questions, please contact us at hello@skynettechnologies.com"
                    )}
                </Modal.Body>
                <Modal.Footer className="d-flex justify-content-center">
                    <Button
                        variant="primary"
                        size="lg"
                        onClick={() => navigateDeletedAccount()}
                    >
                        {t("Ok")}
                    </Button>
                </Modal.Footer>
            </Modal>
            
            <Modal
                show={showEmailChangeConfirm}
                onHide={() => setShowEmailChangeConfirm(false)}
                centered
                backdrop="static"
            >
                <Modal.Header closeButton>
                    <Modal.Title>{t("Change Email?")}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {t("Are you sure you want to change your email address?")}
                </Modal.Body>
                <Modal.Footer>
                    <Button
                        variant="danger"
                        size="lg"
                        onClick={handleEmailChangeConfirm}
                    >
                        {t("Yes, Change")}
                    </Button>

                    <Button
                        variant="secondary"
                        size="lg"
                        onClick={() => {
                            setShowEmailChangeConfirm(false);
                            setNewEmailTemp(userEmail);
                        }}
                    >
                        {t("Cancel")}
                    </Button>
                </Modal.Footer>
            </Modal>

            {/* OTP Modal for Email Change */}
            <Modal
                show={showEmailOTPModal}
                onHide={handleEmailOTPModalClose}
                centered
                backdrop="static"
            >
                <Modal.Header closeButton>
                    <Modal.Title>{t("Verify Email Change")}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form.Label htmlFor="emailOtp">
                        {t("authentication code or recovery code")}{" "}
                        <span className="text-danger">*</span>
                    </Form.Label>
                    <InputGroup className="mb-3">
                        <Form.Control
                            type="text"
                            aria-label="Email OTP"
                            placeholder={t("enter 6-digit OTP or recovery code")}
                            onChange={(e) => setEmailOtp(e.target.value)}
                            value={emailOtp}
                            maxLength={24}
                            size="lg"
                        />
                    </InputGroup>
                    {emailOtpError && (
                        <Alert variant="danger" className="mt-3">
                            {emailOtpError}
                        </Alert>
                    )}
                </Modal.Body>
                <Modal.Footer>
                    <Button
                        variant="primary"
                        size="lg"
                        onClick={confirmEmailChangeWithOTP}
                    >
                        {t("Verify & Change Email")}
                    </Button>
                    <Button
                        variant="secondary"
                        size="lg"
                        onClick={handleEmailOTPModalClose}
                    >
                        {t("Cancel")}
                    </Button>
                </Modal.Footer>
            </Modal>

            {/* confirmation popup for country change */}
            {isMigratedFromNonEU && currentWebsite ? (
                <EUServerMigrationPopup
                    isShow={isMigratedFromNonEU ? 1 : 0}
                    isMigratedFlag={true}
                    isFirstTimeLoad={false}
                    widgetAPIKey={
                        currentWebsite.current_package_only &&
                        currentWebsite.current_package_only.length > 0
                            ? currentWebsite.current_package_only[0].api_key
                            : null
                    }
                    widgetPosition={
                        currentWebsite.widget_position !== null
                            ? currentWebsite.widget_position
                            : `bottom_right`
                    }
                    widgetColor={
                        currentWebsite.widget_color_code !== null
                            ? currentWebsite.widget_color_code
                            : `#420083`
                    }
                    revertBackToOriginalLanguage={revertBackToOriginalLanguage}
                />
            ) : (
                <></>
            )}
        </>
    );
};

export default EditPersonalInformation;